import { DASHBOARD_MAINCONTENT_HEADER, SIP_CONNECTION_STATUS } from "../types";

export const mainContentHeader = header => {
  return {
    type: DASHBOARD_MAINCONTENT_HEADER,
    payload: header,
  };
};

export const sipConnectionStatus = content => {
  return {
    type: SIP_CONNECTION_STATUS,
    payload: content,
  };
};
